<template>
  <span class="tag" :class="classes">
    <slot/>
  </span>
</template>

<script>
export default {
  name: 'KTag',
  props: {
    color: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    classes() {
      if (this.color !== 'default') return ` -color-${this.color}`
      return ''
    }
  }
};
</script>

<style lang='scss' scoped>
@import "@/assets/scss/main.scss";;

.tag {
  display: block;
  background: lighten($primary-3, 20%);
  color: $primary-3;
  padding: $spacing-xxs;
  border-radius: 4px;
  // font-size: $size-1;
  max-width: fit-content;
  @include body-3;

  &.-color-primary-1 {
    background: lighten($primary-1, 20%);
    color: $primary-1;
  }
  &.-color-primary-2 {
    background: lighten($primary-2, 20%);
    color: $primary-2;
  }
  &.-color-primary-3 {
    background: lighten($primary-3, 20%);
    color: $primary-3;
  }
  &.-color-primary-4 {
    background: lighten($primary-4, 20%);
    color: $primary-4;
  }
  &.-color-primary-5 {
    background: lighten($primary-5, 20%);
    color: $primary-5;
  }
  &.-color-primary-6 {
    background: lighten($primary-6, 20%);
    color: $primary-6;
  }
  &.-color-primary-7 {
    background: lighten($primary-7, 20%);
    color: $primary-7;
  }
  &.-color-primary-8 {
    background: lighten($primary-8, 20%);
    color: $primary-8;
  }
  &.-color-primary-9 {
    background: lighten($primary-9, 20%);
    color: $primary-9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/KaledoComponents/KTag.vue